import { keepPreviousData } from '@tanstack/react-query';
import type { TRPC } from './types';
import type { Locale } from '@/lib/enums/locale.enum';
import type { IMarketingListToolFilter } from '@/components/content/MarketingListTool/interfaces/marketingListToolFilter.interface';
import type { MarketingListExportType } from '@/components/content/MarketingListTool/DownloadResults';

const FILTERS_STALE_TIME = 5 * 60 * 1000;
const DATA_STALE_TIME = 30 * 1000;

export const marketingKeys = {
  personFilters: (trpc: TRPC) => trpc.marketing.personFilters.pathKey(),
  companyFilters: (trpc: TRPC) => trpc.marketing.companyFilters.pathKey(),
  personData: (trpc: TRPC) => trpc.marketing.personData.pathKey(),
  companyData: (trpc: TRPC) => trpc.marketing.companyData.pathKey(),
  limits: (trpc: TRPC) => trpc.marketing.limits.pathKey(),
};

export const personFiltersQueryOptions = ({ trpc, locale, enabled = true }: { trpc: TRPC; locale: Locale; enabled?: boolean }) =>
  trpc.marketing.personFilters.queryOptions({ locale }, { enabled, staleTime: FILTERS_STALE_TIME });

export const companyFiltersQueryOptions = ({ trpc, locale, enabled = true }: { trpc: TRPC; locale: Locale; enabled?: boolean }) =>
  trpc.marketing.companyFilters.queryOptions({ locale }, { enabled, staleTime: FILTERS_STALE_TIME });

type DataArgs = {
  trpc: TRPC;
  filter: IMarketingListToolFilter;
  page: number;
  enabled?: boolean;
};

export const personDataQueryOptions = ({ trpc, filter, page, enabled = true }: DataArgs) =>
  trpc.marketing.personData.queryOptions(
    { filter, page },
    {
      enabled,
      placeholderData: keepPreviousData,
      staleTime: DATA_STALE_TIME,
    },
  );

export const companyDataQueryOptions = ({ trpc, filter, page, enabled = true }: DataArgs) =>
  trpc.marketing.companyData.queryOptions(
    { filter, page },
    {
      enabled,
      placeholderData: keepPreviousData,
      staleTime: DATA_STALE_TIME,
    },
  );

export const limitsQueryOptions = ({ trpc, enabled = true }: { trpc: TRPC; enabled?: boolean }) =>
  trpc.marketing.limits.queryOptions(undefined, { enabled, staleTime: DATA_STALE_TIME });

export const downloadUrlQueryOptions = ({ trpc, type }: { trpc: TRPC; type: MarketingListExportType }) =>
  trpc.marketing.downloadUrl.queryOptions({ type }, { staleTime: Infinity });
